import { ReactNode } from 'react'
import { clsx } from 'clsx'

interface BadgeProps {
  children: ReactNode
  variant?: 'default' | 'cyan' | 'purple' | 'green' | 'amber' | 'red'
  size?: 'sm' | 'md'
  className?: string
}

export function Badge({
  children,
  variant = 'default',
  size = 'sm',
  className,
}: BadgeProps) {
  const baseStyles = 'inline-flex items-center font-medium rounded-full'

  const variants = {
    default: 'bg-white/10 text-gray-300 border border-white/10',
    cyan: 'bg-accent-cyan/10 text-accent-cyan border border-accent-cyan/20',
    purple: 'bg-accent-purple/10 text-accent-purple border border-accent-purple/20',
    green: 'bg-accent-green/10 text-accent-green border border-accent-green/20',
    amber: 'bg-accent-amber/10 text-accent-amber border border-accent-amber/20',
    red: 'bg-red-500/10 text-red-400 border border-red-500/20',
  }

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
  }

  return (
    <span className={clsx(baseStyles, variants[variant], sizes[size], className)}>
      {children}
    </span>
  )
}
